import React from "react";

import PersonalManager from "../../components/APanel/PersonalManager";

export default function APInstructors() {
   return (
      <main className="main">
         <section className="page-wrapper">
            <PersonalManager />
         </section>
      </main>
   );
}
